import axios from 'axios';

const CaseStudyAPI = axios.create({
  baseURL: process.env.REACT_APP_CASE_STUDY_USER,
  headers: {
    'Content-Type': 'application/json',
  },
});

const BaseAPI = axios.create({
  baseURL: process.env.REACT_APP_RADME_MAIN,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { BaseAPI, CaseStudyAPI };
